import { gql } from '@apollo/client';

export const QUERYV3 = gql`
  mutation ReactivateSubscriptionV3ByToken($token: String!, $payload: AutoFilledReactivateSubscriptionPayloadV2) {
    reactivateSubscriptionV3ByToken(token: $token, payload: $payload) {
      downgradeToProduct
      downgradeToPrice
      startDate
      endDate
      cancelDate
      frequency
      status
      paymentRetryCount
      paymentReminderEndDate
      has3dsVerification
      reminder3dsEndDate
      billingCycleCount
      nextActionUrl
      amountDue
      lastPaymentDate
      nextPaymentAttemptDate
      terminateDate
      isCancelling
      cancelReason
      planRelationId
      _id
      createdAt
      updatedAt
      incompleteBillingDetails
      nextBillingDate
      renewalReminderDate
      isCancelling
    }
  }
`;
